import React, { useState } from 'react';
import axios from 'axios';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KINDS = [['donations', 'Donations'], ['applications', 'Membership Applications']];

export const ExportPanel = ({ token, onUnauthorized }) => {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [busy, setBusy] = useState('');

  const download = async (kind) => {
    if (from && to && from > to) return window.alert('"From" date must be before "To" date');
    setBusy(kind);
    try {
      const res = await axios.get(`${API}/admin/export/${kind}`, {
        params: { from: from || undefined, to: to || undefined },
        headers: { Authorization: `Bearer ${token}` }, responseType: 'blob',
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `jbss-${kind}-${from || 'all'}-to-${to || 'all'}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      if (e?.response?.status === 401) onUnauthorized();
      else window.alert('Export failed');
    } finally { setBusy(''); }
  };

  return (
    <section className="jbss-visit-stats" data-testid="admin-export">
      <div className="jbss-announce-box"><div className="jbss-export-row">
        <div><Label htmlFor="exp-from" className="jbss-admin-label">From</Label>
          <Input id="exp-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="admin-export-from" /></div>
        <div><Label htmlFor="exp-to" className="jbss-admin-label">To</Label>
          <Input id="exp-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} data-testid="admin-export-to" /></div>
        {KINDS.map(([kind, label]) => (
          <Button key={kind} variant="outline" onClick={() => download(kind)} disabled={!!busy} data-testid={`admin-export-${kind}`}>
            {busy === kind ? <Loader2 className="jbss-spin" size={15} /> : <FileSpreadsheet size={15} />} {label}
          </Button>
        ))}
      </div></div>
    </section>
  );
};
